import React from "react";

const PageNotFound = () => {
  return (
    <div className="td_notfound_wrapper">
      <div className="td_notfound_card">
        {/* Font Awesome 404 Icon */}
        <div className="td_notfound_icon_wrapper">
          <i className="fa-regular fa-circle-xmark td_notfound_icon_fa"></i>
        </div>


        <h2 className="td_fs_32 td_bold td_heading_color td_mb_20">
          Page Not Found
        </h2>

        <p className="td_fs_18 td_medium_color td_mb_30">
          Oops! The page you're looking for doesn't exist or may have been
          moved.
        </p>

        <div className="td_notfound_info_box td_mb_30">
          <p className="td_fs_16">
            If you believe this is an error, please contact{" "}
            <strong>University of Nepal</strong> for assistance.
          </p>
        </div>

        <div className="td_notfound_actions">
          <a href="/" className="td_btn_primary">
            <i className="fa-solid fa-house"></i> Back to Home
          </a>
          <button
            className="td_btn_secondary"
            onClick={() => window.history.back()}
          >
            <i className="fa-solid fa-arrow-left"></i> Go Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default PageNotFound;

